import { Box, Stack } from "@mui/material";
import i18n from "src/i18n";

/**
 * Charge Wallet Tour Steps:
 * 0: body (Welcome)
 * 1: #toobar-credit-details - Credit popper trigger
 * 2: #popper-credit-details - Credit popper content
 * 3: #charge-amount-cards - Balance page
 * 4: body (Completion)
 */
export const chargeWalletTourSteps = (isMobile) => [
    {
        target: "body",
        title: <Stack justifyContent="center" alignItems="center">
            <img width={50} style={{ objectFit: "cover" }} src="/static/hand-up.webp" />
            {i18n.t("tutorial.chargeWalletTour.title")}
        </Stack>,
        content: i18n.t("tutorial.chargeWalletTour.step1"),
        placement: "center",
    },
    {
        target: "#toobar-credit-details",
        content: i18n.t("tutorial.chargeWalletTour.step2"),
        placement: "bottom",
    },
    {
        target: "#popper-credit-details",
        content: i18n.t("tutorial.chargeWalletTour.step3"),
        placement: "right",
    },
    {
        target: "#charge-amount-cards",
        content: i18n.t("tutorial.chargeWalletTour.step4"),
        placement: "top",
    },
    {
        target: "body",
        title: <Box display="flex" justifyContent="center" alignItems="center">
            <img width={50} style={{ objectFit: "cover" }} src="/static/rocket.png" />
        </Box>,
        content: i18n.t("tutorial.chargeWalletTour.end"),
        placement: "center",
    },
];
